import { format } from 'date-fns/esm'
import { useCallback } from 'react'

import { setMainSelection } from '@/atoms'
import { changeCalendarRange as changeCalendarRangeAction } from '@/features/domain/ui'
import { useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'

export const useOnChangeCalenderRange = () => {
  const dispatch = useAppDispatch()
  const toast = useNotification()

  const onChangeCalenderRange = useCallback(
    async (start?: string, end?: string, orderId?: string) => {
      try {
        const today = format(Date.now(), 'yyyyMMdd')
        const minDate = start ?? today
        const maxDate = end ?? today

        const result = await dispatch(changeCalendarRangeAction({ minDate, maxDate }))

        if (changeCalendarRangeAction.rejected.match(result)) {
          throw new Error(result.payload?.message ?? 'Internal error')
        }

        //open order preview when the eligiblity date is edited in a recurrence order
        if (orderId) {
          setMainSelection('orderSteps', [orderId])
        }
      } catch (e) {
        toast.error(e)
      }
    },
    [dispatch, toast],
  )

  return {
    onChangeCalenderRange,
  } as const
}
